import { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import { EDialogAction } from "../Enum/DialogActionEnum";
import JobTitlesDialogBox from "./JobTitlesDialogBox";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import JobSkillDialogBox from "../JobSkills/JobSkillDialogBox";
import JobExtraDialogBox from "../JobExtra/JobExtraDialogBox";
import { TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, Table, CircularProgress, TableFooter, TablePagination, Button } from "@mui/material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { DeleteOutline, EditOutlined, OpenInNew } from "@mui/icons-material";
const JobTitlesTable = (props: { filter: any }) => {
  const theme = useTheme();
  const [jobTitle, setJobTitle] = useState(null);
  const [skill, setSkill] = useState(null);
  const [jobSkillList, setJobSkillList] = useState(null);
  const [jobTitleList, setJobTitleList] = useState<any[]>([]);
  const [skillList, setSkillList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [skillDialogVisibility, setSkillDialogVisibility] = useState(false);  
  const [jobExtraDialogVisibility, setJobExtraDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);

  const { isLoading, changeLoading } = useContext(LoadingStateContext);
  const [limit, setLimit] = useState(10);
  useEffect(() => {
    getJobTitleList();
  }, [page,limit, props.filter]);

  useEffect(() => {
    if (jobTitleList.length > 0) {
      jobTitleList.forEach((jobTitle) => {
        getSkillListByJobId(jobTitle.id);
      });
    }
  }, [jobTitleList]);

  const getJobTitleList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(
        `/v1/job-titles?type=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {
          params: props.filter,
        }
      );

      const data = response.data;
      setJobTitleList(data.result.data);

      setTotalItems(data.result.total);

    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getSkillListByJobId = async (jobId: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/job-title-skills?job_title_id=${jobId}`,
        {}
      );

      const data = response.data;
      // setSkillList((prevSkillList) => [...prevSkillList, ...data.result]);
      setSkillList((prevSkillList) => {
        const existingSkillIds = prevSkillList.map((skill) => skill.id);
        const newSkills = data.result.filter(
          (skill: any) => !existingSkillIds.includes(skill.id)
        );
        return [...prevSkillList, ...newSkills];
      });

    } catch (err) {
      console.log(err);
    }
  };

  const getJobTitleById = async (jobTitle: number, action: EDialogAction) => {
    try {
      const response = await axiosInstance.get(
        `/v1/job-titles/${jobTitle}`,
        {}
      );

      const data = response.data;

      setJobTitle(data.result);

      if (action == EDialogAction.edit) {

        setEditDialogVisibility(true);

      } else if (action == EDialogAction.view) {

        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };
  const deleteJobSkill = async (jobSkillId: number) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/job-title-skills/${jobSkillId}`;

      const response = await axiosInstance.delete(url);
      // getJobList(resume.id);

      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  };
  const goToNextPage = () => {

    setPage(page + 1);
  };

  const goToPreviousPage = () => {
    setPage(page - 1);
  };

  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    setSkillDialogVisibility(false);
    setJobExtraDialogVisibility(false);
    if (action == EDialogAction.edit) {
    } else if (action == EDialogAction.view) {
    } else if (action == EDialogAction.delete) {
    }
    getJobTitleList();
  }

  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getJobTitleList();
  }

  return (
    <>
      <JobTitlesDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={jobTitle}
        dialogAction={dialogAction}
      />

      <JobSkillDialogBox
        open={skillDialogVisibility}
        onClose={editDialogClose}
        data={jobTitle}
        dialogAction={dialogAction}
      />

      <JobExtraDialogBox
        open={jobExtraDialogVisibility}
        onClose={editDialogClose}
        data={jobTitle}
        dialogAction={dialogAction}
      />

      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={jobTitle}
        action="jobTitle"
      />

      <Paper>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Skills</TableCell>
                <TableCell>Extras</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading && jobTitleList.map((data: any, key: number) => {
                const skillsForJob = skillList.filter(
                  (skill) => skill.job_title_id == data.id
                );
                const uniqueSkillsForJob = Array.from(
                  new Set(skillsForJob.map((skill) => skill.skill_id))
                ).map((skillId) =>
                  skillsForJob.find((skill) => skill.skill_id == skillId)
                );
                return (
                  <TableRow key={data.id}>
                    <TableCell>{data.id}</TableCell>
                    <TableCell>{data.title}</TableCell>
                    <TableCell>{data.type == "dom" ? "Domestic" : "Corporate"}</TableCell>
                    <TableCell>
                      <div className="flex  flex-wrap flex-cols-6 mt-2 ">
                        {uniqueSkillsForJob.map((skill, index) => {
                          return (
                            <div
                              key={index}
                              className=" flex justify-center border border-slate-500 rounded-lg px-2 mt-1"
                            >
                              {skill && skill.skill && skill.skill.skill_name}
                              {
                                <button
                                  onClick={() => {
                                    deleteJobSkill(skill.id);
                                  }}
                                >
                                  <CancelIcon
                                    className="ml-2 cursor-pointer"
                                    fontSize="inherit"
                                  />
                                </button>
                              }
                            </div>
                          );
                        })}
                      </div>
                      <div>
                        <button
                          className="  hover:text-blue-500 text-blue-300 font-bold mt-2 text-sm "
                          onClick={() => {
                            setSkillDialogVisibility(true);
                            getJobTitleById(data.id, EDialogAction.create);
                          }}
                        >
                          <div className="flex text-center mt-1">
                            <AddIcon fontSize="small" />

                            <p className="text-sm ">Add</p>
                          </div>
                        </button>
                      </div>
                    </TableCell>

                    <TableCell>
                      <div className="flex flex-wrap">
                        {data.extra && JSON.parse(data.extra).map((extra: any, index: number) => (
                          <div
                            key={index}
                            className="border border-slate-500 rounded-lg px-2 mt-1 mr-2"
                          >
                            {extra}
                          </div>
                        ))}
                      </div>
                      <div>
                        <button
                          className="  hover:text-blue-500 text-blue-300 font-bold mt-2 text-sm "
                          onClick={() => {
                            setJobExtraDialogVisibility(true);
                            setJobTitle(data);
                          }}
                        >
                          <div className="flex text-center mt-1">
                            <AddIcon fontSize="small" />

                            <p className="text-sm ">Update</p>
                          </div>
                        </button>
                      </div>
                    </TableCell>

                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          getJobTitleById(data.id, EDialogAction.view);
                        }}
                      >
                        <OpenInNew/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          getJobTitleById(data.id, EDialogAction.edit);
                        }}
                      >
                        <EditOutlined/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          getJobTitleById(data.id, EDialogAction.delete);
                        }}
                      >
                        <DeleteOutline/>
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
              component="div"
              rowsPerPageOptions={[5, 10, 25]}
              count={totalItems}
              rowsPerPage={limit}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </TableContainer>
        
      </Paper>
      <div className="h-12"></div>
    </>
  );
};

export default JobTitlesTable;
